<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Student Leave Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined
                            @change="getStd()" persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                    <v-col sm="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                            :items="std_div_list" item-text="std" label="Select Standard" outlined @change="getDiv"
                            persistent-hint hint="Please Select Standard" />
                    </v-col>
                    <v-col sm="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object
                            :items="div_list" item-text="div_name" label="Select Division" outlined persistent-hint
                            hint="Please Select Division" />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn @click="getStudentLeaveReport()" :disabled="sel_std_data == null" :loading="fetch_loader"
                        class="button mt-7 pt-0">Fetch</v-btn>
                </v-row>
            </v-card>
            <v-card v-if="this.childrenList != ''" class="box">
                <v-data-table :headers="headers" :items="childrenList" :search="search" class="elevation-1">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Leave Applications</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" background-color="white" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-toolbar>
                    </template>

                    <template v-slot:[`item.attachments`]="{ item }">
                        <span v-if="item.attachments != null">
                            <a target="_blank" :href="basepath + item.attachments">Attachment</a>
                        </span>
                        <span v-else>-</span>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        search: '',
        loader: false,
        // extraBreadcrumbItems: [

        // ],
        breadcrumbClass: "breadcrumb-style1",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        ay_std_div_list: null,
        sel_ay_data: null,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        div: null,
        childrenList: [],
        basepath: null,
        headers: [{
                text: "Child Name",
                value: "Student_Name",
                sortable: true
            },
            {
                text: "Roll No",
                value: "Roll_No",
                sortable: true
            },
            {
                text: "Registration No",
                value: "Registration_No",
                sortable: true
            },
            {
                text: "Standard",
                value: "Standard",
                sortable: true
            },
            {
                text: "Division",
                value: "Division",
                sortable: true
            },
            {
                text: "Reason",
                value: "Reason",
                sortable: true
            },
            {
                text: "From",
                value: "From",
                sortable: true
            },
            {
                text: "To",
                value: "To",
                sortable: true
            },
            {
                text: "Attachment",
                value: "attachments",
                sortable: true
            }
        ],
    }),
    methods: {
        getStudentLeaveReport() {
            this.childrenList = [];
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                division_offering: this.div,
            };
            this.fetch_loader = true;
            axios
                .post("/Academics/getStudentLeaveReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if (res.data.studentList.length != 0) {
                            this.childrenList = res.data.studentList
                        } else {
                            this.showSnackbar("#b71c1c", "No Leave Applications Found!"); // show snackbar on error
                        }
                        this.fetch_loader = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.fetch_loader = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                });
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            this.div_list = ["All"];
            this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            this.div_list.unshift("All");
            this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    //this.sel_ay_data = res.data.curr_ay;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {});
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onload();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
    // computed: {
    //     bookList1() {
    //         return this.self_apprisal_level_linking_list.filter((d) => {
    //             return Object.keys(this.filters).every((f) => {
    //                 return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //             });
    //         });
    //     },
    // },
};
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.dialogview {
    overflow: hidden;
}

.box1 {
    width: 100%;
    overflow: hidden;
    border: 2px solid #8360c3;
}

.viewdesc {
    cursor: pointer;
}
</style>
